import React, { useState } from 'react';
import { Form, Button } from 'antd';
import AuthInfo from '../../components/AuthInfo/AuthInfo';
import AuthForm from '../../components/AuthForm/AuthForm';
import './ForgotPassword.scss';

const AllSet = () => {
  const [viewForm, setViewForm] = useState(false);
  return (
    <div className='auth auth--details auth--no-info-mobile login'>
      <AuthInfo
        className={viewForm ? 'hide' : null}
        title={<>Welcome back</>}
        description={<>Enter your credentials to access your Realbricks account.</>}
      >
        <div className='mobile-action' onClick={() => setViewForm(true)}>
          <Button className='w-100'>Get Started</Button>
        </div>
      </AuthInfo>
      <AuthForm 
        className={viewForm ? 'show' : null} 
        title={<>You’re all set</>} 
        description={<>You have successfully reset your password.</>}
      >
        <Form className='auth-form pin-form login-pin'>
          <Form.Item>
            <Button 
              htmlType='submit' 
              type='primary' 
              className='ant-btn-primary--alt'
              // onClick={() => localStorage.clear()}
              href='/login' 
              target="_blank"
            >
              Go to log in
            </Button>
          </Form.Item>
        </Form>
      </AuthForm>
    </div>
  );
};

export default AllSet;
